"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAvroEventsHub = void 0;
const createAvroEventsHub = () => ({
    hub: Object.create({
        preEmit: Object.create(null),
        postEmit: Object.create(null),
    }),
    emitFunction: async function (eventData, eventType) {
        console.log('[Default Avro Events Console Emit Function] emitting: ' +
            JSON.stringify(eventData) +
            ' as type ' +
            eventType);
        return true;
    },
    emit: async function (eventData, eventName) {
        ;
        (this.hub.preEmit[eventName] || []).forEach((handler) => handler(eventName, eventData));
        return this.emitFunction(eventData, eventName).then((this.hub.postEmit[eventName] || []).forEach((handler) => handler(eventName, eventData)));
    },
    preEmit(eventName, handler) {
        if (!this.hub.preEmit[eventName])
            this.hub.preEmit[eventName] = [];
        this.hub.preEmit[eventName].push(handler);
    },
    postEmit(eventName, handler) {
        if (!this.hub.postEmit[eventName])
            this.hub.postEmit[eventName] = [];
        this.hub.postEmit[eventName].push(handler);
    },
    removePreEmit(eventName, handler) {
        var _a;
        const i = (this.hub.preEmit[eventName] || []).findIndex((h) => h === handler);
        if (i > -1)
            this.hub.preEmit[eventName].splice(i, 1);
        if (((_a = this.hub.preEmit[eventName]) === null || _a === void 0 ? void 0 : _a.length) === 0)
            delete this.hub.preEmit[eventName];
    },
    removePostEmit(eventName, handler) {
        var _a;
        const i = (this.hub.postEmit[eventName] || []).findIndex((h) => h === handler);
        if (i > -1)
            this.hub.postEmit[eventName].splice(i, 1);
        if (((_a = this.hub.postEmit[eventName]) === null || _a === void 0 ? void 0 : _a.length) === 0)
            delete this.hub.postEmit[eventName];
    },
});
exports.createAvroEventsHub = createAvroEventsHub;
